import { useTheme } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import type { CustomSvgIconsProps, SvgPathProps } from './CustomSvgIcons.types';

const SvgPath = ({
  iconType,
  shapeId,
  solidColor,
}: SvgPathProps): React.ReactElement => {
  const iconTypeToStrokeWidth = {
    bold: '1.4',
    normal: '1',
    thin: '0.8',
  };

  const strokeWidth = iconTypeToStrokeWidth[iconType || 'normal'];

  return (
    <>
      <path
        d="M25.375 6.04166C25.375 8.04369 20.5061 9.66666 14.5 9.66666C8.4939 9.66666 3.625 8.04369 3.625 6.04166M25.375 6.04166C25.375 4.03962 20.5061 2.41666 14.5 2.41666C8.4939 2.41666 3.625 4.03962 3.625 6.04166M25.375 6.04166V22.9583C25.375 24.9642 20.5417 26.5833 14.5 26.5833C8.45833 26.5833 3.625 24.9642 3.625 22.9583V6.04166M25.375 11.7452C25.375 13.7511 20.5417 15.3702 14.5 15.3702C8.45833 15.3702 3.625 13.7511 3.625 11.7452M25.375 17.4483C25.375 19.4542 20.5417 21.0733 14.5 21.0733C8.45833 21.0733 3.625 19.4542 3.625 17.4483"
        stroke={solidColor ? 'currentColor' : ''}
        fill="none"
        id={`${shapeId}_database`}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g>
        <path
          d="M20 27.25C21.2426 27.25 22.25 26.2426 22.25 25C22.25 23.7574 21.2426 22.75 20 22.75C18.7574 22.75 17.75 23.7574 17.75 25C17.75 26.2426 18.7574 27.25 20 27.25Z"
          fill="black"
        />
        <path
          d="M25.0455 27.0455C24.9547 27.2511 24.9276 27.4792 24.9677 27.7004C25.0078 27.9216 25.1133 28.1257 25.2705 28.2864L25.3114 28.3273C25.4382 28.4539 25.5387 28.6043 25.6074 28.7699C25.676 28.9354 25.7113 29.1128 25.7113 29.292C25.7113 29.4712 25.676 29.6487 25.6074 29.8142C25.5387 29.9798 25.4382 30.1302 25.3114 30.2568C25.1847 30.3836 25.0343 30.4842 24.8688 30.5528C24.7032 30.6214 24.5258 30.6568 24.3466 30.6568C24.1674 30.6568 23.9899 30.6214 23.8244 30.5528C23.6589 30.4842 23.5085 30.3836 23.3818 30.2568L23.3409 30.2159C23.1802 30.0587 22.9761 29.9533 22.7549 29.9132C22.5338 29.8731 22.3056 29.9001 22.1 29.9909C21.8983 30.0773 21.7264 30.2208 21.6052 30.4038C21.4841 30.5867 21.4191 30.8011 21.4182 31.0205V31.1364C21.4182 31.498 21.2745 31.8449 21.0188 32.1006C20.7631 32.3563 20.4162 32.5 20.0545 32.5C19.6929 32.5 19.346 32.3563 19.0903 32.1006C18.8346 31.8449 18.6909 31.498 18.6909 31.1364V31.075C18.6856 30.8493 18.6126 30.6305 18.4813 30.4468C18.3499 30.2632 18.1664 30.1234 17.9545 30.0455C17.7489 29.9547 17.5208 29.9276 17.2996 29.9677C17.0784 30.0078 16.8743 30.1133 16.7136 30.2705L16.6727 30.3114C16.5461 30.4382 16.3957 30.5387 16.2301 30.6074C16.0646 30.676 15.8872 30.7113 15.708 30.7113C15.5288 30.7113 15.3513 30.676 15.1858 30.6074C15.0202 30.5387 14.8698 30.4382 14.7432 30.3114C14.6164 30.1847 14.5158 30.0343 14.4472 29.8688C14.3786 29.7032 14.3432 29.5258 14.3432 29.3466C14.3432 29.1674 14.3786 28.9899 14.4472 28.8244C14.5158 28.6589 14.6164 28.5085 14.7432 28.3818L14.7841 28.3409C14.9413 28.1802 15.0467 27.9761 15.0868 27.7549C15.1269 27.5338 15.0999 27.3056 15.0091 27.1C14.9227 26.8983 14.7792 26.7264 14.5962 26.6052C14.4133 26.4841 14.1989 26.4191 13.9795 26.4182H13.8636C13.502 26.4182 13.1551 26.2745 12.8994 26.0188C12.6437 25.7631 12.5 25.4162 12.5 25.0545C12.5 24.6929 12.6437 24.346 12.8994 24.0903C13.1551 23.8346 13.502 23.6909 13.8636 23.6909H13.925C14.1507 23.6856 14.3695 23.6126 14.5532 23.4813C14.7368 23.3499 14.8766 23.1664 14.9545 22.9545C15.0453 22.7489 15.0724 22.5208 15.0323 22.2996C14.9922 22.0784 14.8867 21.8743 14.7295 21.7136L14.6886 21.6727C14.5619 21.5461 14.4613 21.3957 14.3926 21.2301C14.324 21.0646 14.2887 20.8872 14.2887 20.708C14.2887 20.5288 14.324 20.3513 14.3926 20.1858C14.4613 20.0202 14.5619 19.8698 14.6886 19.7432C14.8153 19.6164 14.9657 19.5158 15.1312 19.4472C15.2968 19.3786 15.4742 19.3432 15.6534 19.3432C15.8326 19.3432 16.0101 19.3786 16.1756 19.4472C16.3411 19.5158 16.4915 19.6164 16.6182 19.7432L16.6591 19.7841C16.8198 19.9413 17.0239 20.0467 17.2451 20.0868C17.4662 20.1269 17.6944 20.0999 17.9 20.0091H17.9545C18.1562 19.9227 18.3282 19.7792 18.4493 19.5962C18.5705 19.4133 18.6355 19.1989 18.6364 18.9795V18.8636C18.6364 18.502 18.78 18.1551 19.0358 17.8994C19.2915 17.6437 19.6383 17.5 20 17.5C20.3617 17.5 20.7085 17.6437 20.9642 17.8994C21.22 18.1551 21.3636 18.502 21.3636 18.8636V18.925C21.3645 19.1444 21.4295 19.3588 21.5507 19.5417C21.6718 19.7246 21.8438 19.8681 22.0455 19.9545C22.2511 20.0453 22.4792 20.0724 22.7004 20.0323C22.9216 19.9922 23.1257 19.8867 23.2864 19.7295L23.3273 19.6886C23.4539 19.5619 23.6043 19.4613 23.7699 19.3926C23.9354 19.324 24.1128 19.2887 24.292 19.2887C24.4712 19.2887 24.6487 19.324 24.8142 19.3926C24.9798 19.4613 25.1302 19.5619 25.2568 19.6886C25.3836 19.8153 25.4842 19.9657 25.5528 20.1312C25.6214 20.2968 25.6568 20.4742 25.6568 20.6534C25.6568 20.8326 25.6214 21.0101 25.5528 21.1756C25.4842 21.3411 25.3836 21.4915 25.2568 21.6182L25.2159 21.6591C25.0587 21.8198 24.9533 22.0239 24.9132 22.2451C24.8731 22.4662 24.9001 22.6944 24.9909 22.9V22.9545C25.0773 23.1562 25.2208 23.3282 25.4038 23.4493C25.5867 23.5705 25.8011 23.6355 26.0205 23.6364H26.1364C26.498 23.6364 26.8449 23.78 27.1006 24.0358C27.3563 24.2915 27.5 24.6383 27.5 25C27.5 25.3617 27.3563 25.7085 27.1006 25.9642C26.8449 26.22 26.498 26.3636 26.1364 26.3636H26.075C25.8556 26.3645 25.6412 26.4295 25.4583 26.5507C25.2754 26.6718 25.1319 26.8438 25.0455 27.0455Z"
          fill="black"
        />
        <path
          d="M20 27.25C21.2426 27.25 22.25 26.2426 22.25 25C22.25 23.7574 21.2426 22.75 20 22.75C18.7574 22.75 17.75 23.7574 17.75 25C17.75 26.2426 18.7574 27.25 20 27.25Z"
          stroke={solidColor ? 'currentColor' : ''}
          fill="none"
          id={`${shapeId}_circle`}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.0455 27.0455C24.9547 27.2511 24.9276 27.4792 24.9677 27.7004C25.0078 27.9216 25.1133 28.1257 25.2705 28.2864L25.3114 28.3273C25.4382 28.4539 25.5387 28.6043 25.6074 28.7699C25.676 28.9354 25.7113 29.1128 25.7113 29.292C25.7113 29.4712 25.676 29.6487 25.6074 29.8142C25.5387 29.9798 25.4382 30.1302 25.3114 30.2568C25.1847 30.3836 25.0343 30.4842 24.8688 30.5528C24.7032 30.6214 24.5258 30.6568 24.3466 30.6568C24.1674 30.6568 23.9899 30.6214 23.8244 30.5528C23.6589 30.4842 23.5085 30.3836 23.3818 30.2568L23.3409 30.2159C23.1802 30.0587 22.9761 29.9533 22.7549 29.9132C22.5338 29.8731 22.3056 29.9001 22.1 29.9909C21.8983 30.0773 21.7264 30.2208 21.6052 30.4038C21.4841 30.5867 21.4191 30.8011 21.4182 31.0205V31.1364C21.4182 31.498 21.2745 31.8449 21.0188 32.1006C20.7631 32.3563 20.4162 32.5 20.0545 32.5C19.6929 32.5 19.346 32.3563 19.0903 32.1006C18.8346 31.8449 18.6909 31.498 18.6909 31.1364V31.075C18.6856 30.8493 18.6126 30.6305 18.4813 30.4468C18.3499 30.2632 18.1664 30.1234 17.9545 30.0455C17.7489 29.9547 17.5208 29.9276 17.2996 29.9677C17.0784 30.0078 16.8743 30.1133 16.7136 30.2705L16.6727 30.3114C16.5461 30.4382 16.3957 30.5387 16.2301 30.6074C16.0646 30.676 15.8872 30.7113 15.708 30.7113C15.5288 30.7113 15.3513 30.676 15.1858 30.6074C15.0202 30.5387 14.8698 30.4382 14.7432 30.3114C14.6164 30.1847 14.5158 30.0343 14.4472 29.8688C14.3786 29.7032 14.3432 29.5258 14.3432 29.3466C14.3432 29.1674 14.3786 28.9899 14.4472 28.8244C14.5158 28.6589 14.6164 28.5085 14.7432 28.3818L14.7841 28.3409C14.9413 28.1802 15.0467 27.9761 15.0868 27.7549C15.1269 27.5338 15.0999 27.3056 15.0091 27.1C14.9227 26.8983 14.7792 26.7264 14.5962 26.6052C14.4133 26.4841 14.1989 26.4191 13.9795 26.4182H13.8636C13.502 26.4182 13.1551 26.2745 12.8994 26.0188C12.6437 25.7631 12.5 25.4162 12.5 25.0545C12.5 24.6929 12.6437 24.346 12.8994 24.0903C13.1551 23.8346 13.502 23.6909 13.8636 23.6909H13.925C14.1507 23.6856 14.3695 23.6126 14.5532 23.4813C14.7368 23.3499 14.8766 23.1664 14.9545 22.9545C15.0453 22.7489 15.0724 22.5208 15.0323 22.2996C14.9922 22.0784 14.8867 21.8743 14.7295 21.7136L14.6886 21.6727C14.5619 21.5461 14.4613 21.3957 14.3926 21.2301C14.324 21.0646 14.2887 20.8872 14.2887 20.708C14.2887 20.5288 14.324 20.3513 14.3926 20.1858C14.4613 20.0202 14.5619 19.8698 14.6886 19.7432C14.8153 19.6164 14.9657 19.5158 15.1312 19.4472C15.2968 19.3786 15.4742 19.3432 15.6534 19.3432C15.8326 19.3432 16.0101 19.3786 16.1756 19.4472C16.3411 19.5158 16.4915 19.6164 16.6182 19.7432L16.6591 19.7841C16.8198 19.9413 17.0239 20.0467 17.2451 20.0868C17.4662 20.1269 17.6944 20.0999 17.9 20.0091H17.9545C18.1562 19.9227 18.3282 19.7792 18.4493 19.5962C18.5705 19.4133 18.6355 19.1989 18.6364 18.9795V18.8636C18.6364 18.502 18.78 18.1551 19.0358 17.8994C19.2915 17.6437 19.6383 17.5 20 17.5C20.3617 17.5 20.7085 17.6437 20.9642 17.8994C21.22 18.1551 21.3636 18.502 21.3636 18.8636V18.925C21.3645 19.1444 21.4295 19.3588 21.5507 19.5417C21.6718 19.7246 21.8438 19.8681 22.0455 19.9545C22.2511 20.0453 22.4792 20.0724 22.7004 20.0323C22.9216 19.9922 23.1257 19.8867 23.2864 19.7295L23.3273 19.6886C23.4539 19.5619 23.6043 19.4613 23.7699 19.3926C23.9354 19.324 24.1128 19.2887 24.292 19.2887C24.4712 19.2887 24.6487 19.324 24.8142 19.3926C24.9798 19.4613 25.1302 19.5619 25.2568 19.6886C25.3836 19.8153 25.4842 19.9657 25.5528 20.1312C25.6214 20.2968 25.6568 20.4742 25.6568 20.6534C25.6568 20.8326 25.6214 21.0101 25.5528 21.1756C25.4842 21.3411 25.3836 21.4915 25.2568 21.6182L25.2159 21.6591C25.0587 21.8198 24.9533 22.0239 24.9132 22.2451C24.8731 22.4662 24.9001 22.6944 24.9909 22.9V22.9545C25.0773 23.1562 25.2208 23.3282 25.4038 23.4493C25.5867 23.5705 25.8011 23.6355 26.0205 23.6364H26.1364C26.498 23.6364 26.8449 23.78 27.1006 24.0358C27.3563 24.2915 27.5 24.6383 27.5 25C27.5 25.3617 27.3563 25.7085 27.1006 25.9642C26.8449 26.22 26.498 26.3636 26.1364 26.3636H26.075C25.8556 26.3645 25.6412 26.4295 25.4583 26.5507C25.2754 26.6718 25.1319 26.8438 25.0455 27.0455Z"
          stroke={solidColor ? 'currentColor' : ''}
          fill="none"
          id={`${shapeId}_gear`}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </>
  );
};

export const SyntheticDataGenerationIcon = ({
  shouldbegradient,
  transitionduration = 0.4,
  prefix,
  solidColor,
  iconType = 'normal',
  ...props
}: CustomSvgIconsProps): React.ReactElement => {
  const currColorId = `${prefix}_syntheticDataCurrentColorGradient`;
  const newColorId = `${prefix}_syntheticDataNewColorGradient`;
  const shapeId = `${prefix}_syntheticDataShape`;
  const theme = useTheme();
  const isLight = theme.palette.type === 'light';

  const colorsDark = {
    base: {
      start: theme.palette?.greyColors?.PLUS_8,
      stop: theme.palette.greyColors?.PLUS_2,
    },
    hover: {
      start: theme.palette?.greyColors?.PLUS_8,
      stop: theme.palette.aquamarineColors?.PLUS_2,
    },
  };

  const colorsLight = {
    base: {
      start: theme.palette?.greyColors?.PLUS_4,
      stop: theme.palette.greyColors?.PLUS_2,
    },
    hover: {
      start: theme.palette?.aquamarineColors?.PLUS_3,
      stop: theme.palette.aquamarineColors?.PLUS_2,
    },
  };

  const svgColors = isLight ? colorsLight : colorsDark;

  return (
    <SvgIcon {...props} viewBox="0 0 29 34">
      {solidColor ? (
        <SvgPath
          shapeId={shapeId}
          iconType={iconType}
          solidColor={solidColor}
        />
      ) : (
        <>
          <defs>
            <linearGradient
              style={{
                transition: `${transitionduration}s`,
              }}
              id={currColorId}
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%">
              <stop offset="0" stopColor={svgColors.base.start} />
              <stop offset="1" stopColor={svgColors.base.stop} />
            </linearGradient>
            <linearGradient id={newColorId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0" stopColor={svgColors.hover.start} />
              <stop offset="1" stopColor={svgColors.hover.stop} />
            </linearGradient>
          </defs>
          <g
            style={{
              stroke: `url("#${currColorId}")`,
            }}>
            <SvgPath
              shapeId={shapeId}
              iconType={iconType}
              solidColor={solidColor}
            />
          </g>
          <use
            xlinkHref={`#${shapeId}_database`}
            style={{
              stroke: `url("#${newColorId}")`,
              transition: `${transitionduration}s`,
              opacity: shouldbegradient ? 0.5 : 0,
            }}
          />
          <use
            xlinkHref={`#${shapeId}_circle`}
            style={{
              stroke: `url("#${newColorId}")`,
              transition: `${transitionduration}s`,
              opacity: shouldbegradient ? 1 : 0,
            }}
          />
          <use
            xlinkHref={`#${shapeId}_gear`}
            style={{
              stroke: `url("#${newColorId}")`,
              transition: `${transitionduration}s`,
              opacity: shouldbegradient ? 1 : 0,
            }}
          />
        </>
      )}
    </SvgIcon>
  );
};
